<template>
	<div class="page flex-col">
		<div class="block_1 flex-col">
			<img class="title" src="@/assets/images/icon_exchange_title.png" />
			<img class="money" src="@/assets/images/icon_exchange_money.png" />
			<img class="module" src="@/assets/images/icon_exchange_module1.png" />
			<div class="module2">
				<div class="invite-item" v-for="(item, index) in exchangeList" :key="index">
					<div class="invite-left">
						<div class="top-img">
							<img class="people" :src="getPeopleImage(item.limit)" />
							<template v-if="!item.is_exchanged">
								<img v-if="!item.is_completed" class="btn"
									src="@/assets/images/icon_exchange_complete.png" @click="$router.push('/wuxingbi')"
									alt="去完成" />
								<img v-else class="btn" src="@/assets/images/icon_exchange_exchange.png"
									@click="handleExchange(item)" alt="兑换" />
							</template>
							<img v-else class="btn" src="@/assets/images/icon_exchange_exchange.png"
								style="opacity: 0.6;" alt="已兑换" />
						</div>
						<div class="bottom-img">
							<div class="progress-container">
								<img class="progress-img-bg" src="@/assets/images/icon_exchange_progress.png" />
								<div style="width: 85%;">
									<div class="progress-bar-active" :style="{ width: item.progress_percent + '%' }">
									</div>
								</div>
								<div class="progress-num">{{ item.current_count }} / {{ item.limit }}</div>
							</div>
						</div>
					</div>
					<div class="invite-right">
						<img class="invite-coin" src="@/assets/images/icon_exchange_coin.png" />
						<button v-if="!item.is_exchanged" class="invite-btn" @click="showShippingProgress(item)">
							邮寄进度
						</button>
						<button v-else class="invite-btn exchanged-btn" @click="showLogisticsInfo(item)">
							查看物流信息
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- 邮寄进度动图弹窗 -->
		<!-- <van-dialog v-model="showProgressDialog" :show-confirm-button="false" close-on-click-overlay
			class="progress-dialog">
			<div class="gif-container">
				<img :src="require('@/assets/images/icon_exchange_exchange_no.gif')" alt="邮寄进度" />
				<div class="close-btn" @click="showProgressDialog = false">×</div>
			</div>
		</van-dialog> -->

		<!-- 兑换成功弹窗 -->
		<van-dialog v-model="showExchangeDialog" :show-confirm-button="false" close-on-click-overlay
			class="exchange-dialog">
			<div class="exchange-content">
				<div class="dialog-title">
					<img src="@/assets/images/icon_exchange_congratulations.png" />
				</div>
				<p class="dialog-subtitle">恭喜获得{{ currentExchangeWxb }}枚五行币</p>
				<img class="dialog-img" src="@/assets/images/icon_exchange_display.png" />
				<p class="dialog-tips">五行币铸就完成后发放</p>
				<button class="dialog-btn" @click="handleShipping">立即邮寄</button>
			</div>
		</van-dialog>

		<!-- 确认收货地址弹窗 -->
		<van-dialog v-model="showAddressConfirmDialog" title="确认收货地址" show-cancel-button @confirm="confirmShipping"
			@cancel="showAddressConfirmDialog = false">
			<div class="address-confirm-content">
				<div class="address-info" v-if="userAddress">
					<p><strong>收件人：</strong>{{ userAddress.name }}</p>
					<p><strong>电话：</strong>{{ userAddress.phone }}</p>
					<p><strong>地址：</strong>{{ userAddress.address }}</p>
				</div>
				<div class="address-tips" v-else>
					暂无收货地址信息
				</div>
			</div>
		</van-dialog>

		<van-dialog v-model="showExchangeConfirmDialog" title="兑换确认" show-cancel-button @confirm="doExchange"
			@cancel="showExchangeConfirmDialog = false">
			<div class="exchange-confirm-content">
				<p>确认使用 {{ currentExchangeWxb }} 枚五行币兑换奖励吗？</p>
				<p class="tips">兑换后五行币将扣除，奖励将邮寄到您的地址</p>
			</div>
		</van-dialog>

		<!-- 物流信息弹窗 - 修改为popup弹窗 -->
		<van-popup v-model="showLogisticsDialog" class="logistics-popup" :style="{ width: '90%' }" round position="center">
			<div class="logistics-popup-container">
				<!-- 关闭按钮 -->
				<div class="close-btn" @click.stop="showLogisticsDialog = false">
					<van-icon name="cross" color="#999" size="18" />
				</div>
				<!-- 弹窗内容 -->
				<div class="popup-content">
					<img src="@/assets/images/icon_exchange_info.png" alt="物流信息" class="logistics-popup-image" />
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		videoPlayer
	} from "vue-video-player";
	import "video.js/dist/video-js.css";
	import {
		WOW
	} from "wowjs";
	import {
		swiper,
		swiperSlide
	} from "vue-awesome-swiper";
	import VuePlyr from "vue-plyr";
	import "vue-plyr/dist/vue-plyr.css";
	import "swiper/dist/css/swiper.css";
	import Fetch from "../../utils/fetch";
	import Api from "../../interface/index";

	import {
		Swipe,
		SwipeItem,
		Icon,
		Progress,
		Dialog,
		Field,
		Circle,
		Switch,
		Empty,
		Toast,
		Popup
	} from "vant";
	import Clipboard from "v-clipboard";

	Vue.use(Icon).use(Progress).use(Dialog).use(Field).use(Circle).use(Switch).use(Empty).use(Clipboard).use(Toast).use(Popup);

	export default {
		name: "exchange",
		components: {
			VanSwipe: Swipe,
			VanSwipeItem: SwipeItem,
			swiper,
			videoPlayer,
			swiperSlide,
		},
		data() {
			return {
				lang: this.$i18n.locale || "zh_cn",
				data: {},
				// showProgressDialog: false,
				showExchangeDialog: false,
				showLogisticsDialog: false, // 修改为popup弹窗
				showAddressConfirmDialog: false, // 确认地址弹窗
				showExchangeConfirmDialog: false,
				currentExchangeWxb: 0,
				currentExchangeItem: null,
				exchangeList: [],
				hasAddress: false, // 是否有收货地址
				fromExchange: false, // 是否从兑换页面跳转回来
				userAddress: null, // 用户地址信息
				pendingExchangeItem: null,
				isAccountVerification: 0,
			};
		},
		created() {
			this.$parent.footer("exchange");
			if (this.$route.query.from === 'exchange') {
				this.fromExchange = true;
				this.checkAddress();
			}
		},
		mounted() {
			this.start();
			this.loadExchangeData();
			this.checkAddress();
		},
		computed: {
			peopleImages() {
				return {
					3: require('@/assets/images/icon_exchange_3people.png'),
					5: require('@/assets/images/icon_exchange_5people.png'),
					10: require('@/assets/images/icon_exchange_10people.png'),
					20: require('@/assets/images/icon_exchange_20people.png'),
					30: require('@/assets/images/icon_exchange_30people.png'),
					50: require('@/assets/images/icon_exchange_50people.png'),
				};
			}
		},
		methods: {
			start() {
				Fetch("/user/info").then((r) => {
					this.isAccountVerification = r.data.is_account_verification;
				}).catch(e => {
					console.error('Fetch /user/info failed', e);
				});
			},
			// 检查是否有收货地址
			checkAddress() {
				Fetch('/user/address_get').then((r) => {
					if (r.code === 1 && r.data) {
						this.hasAddress = true;
						this.userAddress = r.data;
					} else {
						this.hasAddress = false;
						this.userAddress = null;
					}
				}).catch(() => {
					this.hasAddress = false;
					this.userAddress = null;
				});
			},

			// 加载兑换数据
			loadExchangeData() {
				Fetch("/user/get_exchange_progress").then((r) => {
					this.exchangeList = r.data.rewards || [];
				}).catch(() => {
					this.exchangeList = [{
							reward_id: "exchange_1",
							limit: 3,
							wxb: 3,
							current_count: 0,
							is_completed: false,
							is_exchanged: false,
							progress_percent: 0
						},
						{
							reward_id: "exchange_2",
							limit: 5,
							wxb: 5,
							current_count: 0,
							is_completed: false,
							is_exchanged: false,
							progress_percent: 0
						},
						{
							reward_id: "exchange_3",
							limit: 10,
							wxb: 10,
							current_count: 0,
							is_completed: false,
							is_exchanged: false,
							progress_percent: 0
						},
						{
							reward_id: "exchange_4",
							limit: 20,
							wxb: 20,
							current_count: 0,
							is_completed: false,
							is_exchanged: false,
							progress_percent: 0
						},
						{
							reward_id: "exchange_5",
							limit: 30,
							wxb: 30,
							current_count: 0,
							is_completed: false,
							is_exchanged: false,
							progress_percent: 0
						},
						{
							reward_id: "exchange_6",
							limit: 50,
							wxb: 50,
							current_count: 0,
							is_completed: false,
							is_exchanged: false,
							progress_percent: 0
						},
					];
				});
			},

			// 根据人数获取对应的图片
			getPeopleImage(limit) {
				return this.peopleImages[limit];
			},

			// 显示邮寄进度动图
			showShippingProgress(item) {
				// 如果未兑换，提示用户先兑换
				if (!item.is_exchanged) {
					Toast.fail('未兑换该奖励');
					return;
				}
				this.currentExchangeItem = item;
				// this.showProgressDialog = true;
			},

			// 显示物流信息
			showLogisticsInfo(item) {
				this.showLogisticsDialog = true;
				// 保留原有的逻辑判断
				if (this.isAccountVerification) {
					Toast.success('你的五行币正在打包中');
				} else {
					Toast.fail('需要身份验证后才能查看');
				}
			},

			// 处理兑换
			handleExchange(item) {
				if (!item.is_completed || item.is_exchanged) return;

				// 保存当前兑换项
				this.currentExchangeItem = item;
				this.currentExchangeWxb = item.wxb;
				this.pendingExchangeItem = item; // 保存待兑换项

				// 先检查是否有地址
				if (!this.hasAddress) {
					// 没有地址，跳转到地址填写页面
					Toast.loading({
						message: '请先填写收货地址',
						duration: 1000,
						onClose: () => {
							this.$router.push({
								path: '/address',
								query: {
									from: 'exchange',
									reward_id: item.reward_id
								}
							});
						}
					});
					return;
				}

				// 有地址，先显示地址确认弹窗
				this.showAddressConfirmDialog = true;
			},

			// 立即邮寄
			handleShipping() {
				// 先检查是否有地址
				if (!this.hasAddress) {
					// 没有地址，跳转到地址填写页面
					this.showExchangeDialog = false;
					Toast.loading({
						message: '请先填写收货地址',
						duration: 1000,
						onClose: () => {
							this.$router.push({
								path: '/address',
								query: {
									from: 'exchange',
									reward_id: this.currentExchangeItem.reward_id
								}
							});
						}
					});
					return;
				}

				// 有地址，先显示确认地址弹窗
				this.showExchangeDialog = false;
				this.showAddressConfirmDialog = true;
			},

			// 确认邮寄
			confirmShipping() {
				// 关闭地址确认弹窗
				this.showAddressConfirmDialog = false;

				// 显示兑换确认弹窗
				setTimeout(() => {
					this.showExchangeConfirmDialog = true;
				}, 300);
			},
			doExchange() {
				if (!this.pendingExchangeItem) {
					Toast.fail('兑换信息错误');
					return;
				}

				Fetch("/user/exchange_reward_claimed", {
					reward_id: this.pendingExchangeItem.reward_id
				}).then((r) => {
					Toast.success('兑换成功');
					this.showExchangeConfirmDialog = false;

					// 显示兑换成功弹窗
					setTimeout(() => {
						this.showExchangeDialog = true;
					}, 300);

					// 重新加载兑换数据
					this.loadExchangeData();

					// 重置待兑换项
					this.pendingExchangeItem = null;
				}).catch(err => {
					Toast.fail(err.message || '兑换失败');
					this.showExchangeConfirmDialog = false;
					this.pendingExchangeItem = null;
				});
			},

			// 立即邮寄
			handleShipping() {
				// 关闭兑换成功弹窗
				this.showExchangeDialog = false;

				// 显示邮寄进度
				setTimeout(() => {
					// this.showProgressDialog = true;
					Toast.success('已提交邮寄申请');

					// 3秒后关闭邮寄进度弹窗
					// setTimeout(() => {
					// 	this.showProgressDialog = false;
					// }, 3000);
				}, 500);
			},

		},
	};
</script>

<style src="@/assets/styles/common.css" />
<style lang="less" scoped>
	.page {
		position: relative;
		width: 10rem;
		overflow: hidden;

		.block_1 {
			position: relative;
			width: 10rem;
			background: url(~@/assets/exchange_bg.png) 100% no-repeat;
			background-size: 10rem 100%;
			padding-bottom: 60px;
			background-position: top center;

			.title {
				margin: 2rem .3rem .66rem .3rem;
				width: 9.4rem;
				height: 3.2rem;
			}

			.money {
				margin: 0 auto 0.66rem auto;
				width: 9rem;
			}

			.module {
				width: 9rem;
				margin: 0 .5rem;
			}

			.module2 {
				background: url(~@/assets/images/icon_exchange_module2.png) 100% no-repeat;
				background-size: 9rem 100%;
				padding-top: 1.6rem;
				margin: 0.5rem .5rem .5rem .5rem;
				padding: 1.5rem .5rem 0.2rem .5rem;
				display: flex;
				flex-direction: column;
				align-items: center;

				.invite-coin {
					width: .9rem;
				}

				.people {
					width: 65%;
				}

				.btn {
					width: 30%;
					margin-left: 0.3rem;
					cursor: pointer;
				}
			}
		}
	}

	.invite-item {
		width: 100%;
		background: url(~@/assets/images/icon_exchange_details_bg.png) 100% no-repeat;
		background-size: cover;
		border-radius: 9px;
		padding: .2rem .3rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: .3rem;
	}

	.invite-left {
		line-height: 1.5;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		width: 70%;
	}

	.invite-right {
		width: 30%;
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		padding-left: .3rem;
	}

	.top-img {
		width: 100%;
		display: flex;
	}

	.bottom-img {
		width: 100%;
		margin-top: 0.1rem;
	}

	.progress-container {
		position: relative;
		width: 100%;
		height: 0.4rem;
		margin-top: 0.1rem;

		.progress-img-bg {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			z-index: 1;
		}

		.progress-bar-active {
			max-width: 85%;
			position: absolute;
			top: 50%;
			left: 0;
			height: 0.4rem;
			background: linear-gradient(90deg, #4CAF50, #8BC34A);
			border-radius: 0.2rem;
			z-index: 2;
			transition: width 0.5s ease-in-out;
		}

		.progress-num {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, 0);
			color: #fff;
			font-size: 0.24rem;
			font-weight: bold;
			text-align: center;
			white-space: nowrap;
			text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
			z-index: 3;
		}
	}

	.invite-btn {
		width: 1.8rem;
		height: .8rem;
		border-radius: 9px;
		border: none;
		background: linear-gradient(135deg, #FEE05C, #FE0106);
		color: #fff;
		font-size: 0.28rem;
		font-weight: bold;
		cursor: pointer;
		box-shadow: 0 4px 10px rgba(254, 1, 6, 0.2);
		margin-top: 0.2rem;

		&:disabled {
			background: linear-gradient(135deg, #cccccc, #999999);
			cursor: not-allowed;
			box-shadow: none;
		}
	}

	.exchanged-btn {
		background: linear-gradient(135deg, #4CAF50, #2E7D32);
		box-shadow: 0 4px 10px rgba(76, 175, 80, 0.2);
	}

	.progress-dialog,
	.logistics-dialog {
		background-color: transparent;

		.van-dialog {
			background: transparent;
			box-shadow: none;
			width: 6rem;
		}

		.gif-container {
			position: relative;
			width: 100%;
			margin: 0 auto;

			img {
				width: 100%;
				border-radius: 10px;
			}

			.close-btn {
				position: absolute;
				top: -0.4rem;
				right: -0.4rem;
				width: 0.8rem;
				height: 0.8rem;
				background: rgba(0, 0, 0, 0.7);
				color: white;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				font-size: 0.6rem;
				cursor: pointer;
				z-index: 1000;
			}
		}
	}

	.exchange-dialog {
		background-color: #6396F9;

		.van-dialog {
			width: 7rem;
			border-radius: 20px;
			overflow: hidden;
			background: linear-gradient(135deg, #FFE066, #FF9966);
		}

		.exchange-content {
			padding: 0.6rem;
			text-align: center;

			.dialog-title {
				position: relative;
				height: 2.5rem;

				img {
					width: 140%;
					position: absolute;
					top: -50%;
					transform: translate(-50%, 0);
				}
			}

			.dialog-subtitle {
				font-size: 0.4rem;
				font-weight: bold;
				color: #fff;
				margin-bottom: 0.3rem;
			}

			.dialog-img {
				width: 60%;
				margin: 0.3rem auto;
			}

			.dialog-tips {
				font-size: 0.4rem;
				font-weight: bold;
				color: #fff;
				margin: 0.3rem 0;
			}

			.dialog-btn {
				width: 90%;
				background-color: #ffdc02;
				color: #a85326;
				border: none;
				border-radius: 45px;
				font-size: 0.7rem;
				font-weight: bold;
				margin: 0.3rem auto;
				display: block;
				cursor: pointer;
				box-shadow: 0 4px 10px rgba(255, 87, 34, 0.3);
				padding: 0.2rem 0;
				letter-spacing: 9px;
			}
		}
	}

	.address-confirm-content {
		padding: 20px;

		.address-info {
			line-height: 1.8;

			p {
				margin: 10px 0;
				font-size: 14px;

				strong {
					color: #333;
					margin-right: 5px;
				}
			}
		}

		.address-tips {
			text-align: center;
			color: #999;
			padding: 20px;
			font-size: 14px;
		}
	}

	.exchange-confirm-content {
		padding: 20px;
		text-align: center;

		p {
			margin: 10px 0;
			font-size: 16px;
			color: #333;

			&.tips {
				font-size: 14px;
				color: #999;
			}
		}
	}

	/* 物流信息弹窗样式 */
	.logistics-popup {
		border-radius: 10px;
		overflow: visible;
		/* 改为visible让关闭按钮可以显示在弹窗外 */

		.logistics-popup-container {
			position: relative;

			.close-btn {
				position: absolute;
				top: -10px;
				right: -10px;
				width: 30px;
				height: 30px;
				background: #fff;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
				z-index: 100;
				cursor: pointer;

				&:active {
					background: #f5f5f5;
				}
			}

			.popup-content {
				width: 100%;

				.logistics-popup-image {
					width: 100%;
					height: auto;
					display: block;
					border-radius: 10px;
				}
			}
		}
	}
</style>